<template>

    <m-edit1/>

    <m-courses-1 v-bind='{...{"slicer":12,"paginate":true},...{}}' :style='""' class="" ></m-courses-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mCourses1 from '@moeinmdn/miw-alpha-components/src/package/Course/Archive/Courses1';

export default {
    name: 'HomeView',
    components: {mEdit1, mCourses1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
